import { render, staticRenderFns } from "./GrundtvigChat.vue?vue&type=template&id=c863f136&scoped=true&"
import script from "./GrundtvigChat.vue?vue&type=script&lang=js&"
export * from "./GrundtvigChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c863f136",
  null
  
)

export default component.exports